
<template>
  <div class="addProofing">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">打样记录单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button size="small" class="del" @click="onDelete" :disabled="enableTable||!edit">删除</el-button>
            <el-button size="small" class="add" @click="onAdd" :disabled="enableTable||!edit">增加</el-button>
            <el-button size="small" class="alter" @click="onAlter">修改</el-button>
            <el-button size="small" class="save" v-throttle-button="onSave" :disabled="!enableTable||!edit">保存</el-button>
            <el-button size="small" class="cancel" @click="onRollBack" :disabled="!enableTable||!edit">撤销</el-button>
            <el-button size="small" class="close" @click="closeView">关闭</el-button>
          </div>
          <div class="custom-search-container">
            <div class="custom-search-box">
              
              <div class="custom-search-box-warpper">
                <span>基地</span>
                <el-select v-model="order.fishBaseId" filterable placeholder="请选择" size="small" @change="baseChange" :disabled="Boolean(orderId)||!edit">
                  <el-option v-for="(item, index) in baseLists" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
              <div class="custom-search-box-warpper">
                <span>日期</span>
                <el-date-picker size="small" v-model="order.dataDate" :disabled="!edit"  type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                </el-date-picker>
              </div>
               <div class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input placeholder="请输入单据号" v-model="order.billsNo" size="small" disabled>
                </el-input>
              </div>
             
            </div>
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>塘口</span>
                <el-select v-model="order.pond" filterable placeholder="请选择" size="small" @change="topPondChange" :disabled="Boolean(orderId) ||!edit">
                  <el-option v-for="(item, index) in topPondList" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
                <span v-if="order.pond != ''">&nbsp;&nbsp;&nbsp;周期：{{this.order.fishBatch}}</span>
              </div>
              <div class="custom-search-box-warpper" v-if="show">
                <span>流水号</span>
                <el-input placeholder="请输入流水号" v-model="order.numericalOrder" size="small" disabled>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-container">
        <table-ex :showIndex='true' :enable="enableTable&&edit">
          <thead-ex>
            <th-ex v-if="order.pond == ''">塘口</th-ex>
            <th-ex v-if="order.pond == ''">周期</th-ex>
            <th-ex>品种</th-ex>
            <th-ex>计量单位</th-ex>
            <th-ex>打样总斤数</th-ex>
            <th-ex>均重</th-ex>
            <th-ex>打样数量</th-ex>
            <th-ex>预估存活率(%)</th-ex>
            <th-ex>平均体长(cm)</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex v-for="(item,index) in order.details" :key="index" @selected="selectedRow=item">
              <td-ex v-if="order.pond == ''" v-model="item.pond" :editable="item.pondEdit" :list="fishPondList" display="value" take="key" type='cmb' @selected="pondChange(item)"></td-ex>
              <td-ex v-if="order.pond == ''" v-model="item.fishBatch" :editable="item.pondEdit" type='text'></td-ex>
              <td-ex v-model="item.productId"  v-if="order.pond == ''" :editable="item.fishEdit" type='cmb' :list="item.fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <td-ex v-model="item.productId" v-else :editable="item.fishEdit" type='cmb' :list="fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <td-ex v-model="item.measureUnit"  type='input'  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" ></td-ex>
              <td-ex v-model="item.weight" type='number'   number @input="setQuantityAmount(item)||setAvgWeightAmount(item)" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive :decimalLength="2"></td-ex>              
              <td-ex v-model="item.avgWeight" type='number'   number @input="setQuantityAmount(item)" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive :decimalLength="4"></td-ex>
              <td-ex v-model="item.quantity" type='number'  number @input="setAvgWeightAmount(item)"  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive ></td-ex>
              <td-ex v-model="item.survivalRate" type='number'  number  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive :decimalLength="2"></td-ex>
              <td-ex v-model="item.avgBodyLen" type='number'   number onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive :decimalLength="2"></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex v-model="order.remark" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <td v-if="order.pond == ''">--</td>
            <td v-if="order.pond == ''">--</td>
            <td>--</td>
            <td>--</td>
            <td>{{total('weight')}}</td>
            <td>--</td>
            <td>{{total('quantity')}}</td>
            <td>--</td>
            <td>--</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
export default {
  name: "addProofing",
  data() {
    return {
      edit: !!this.$route.query.edit,
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      addBaseList: true,
      editBaseList: false,
      num: 3,
      show: false,
      delBtnDisable: true,
      addBtnDisable: true,
      alterBtnDisable: true,
      saveBtnDisable: false,
      rollBackBtnDisable: false,
      closeBtnDisable: false,
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        dataDate: new Date(),
        numericalOrder: 0,
        pond: "",
        fishBatch: "",
        fishBatchId: "",
        billsNo: 0,
        remark: "",
        details: []
      },
      pondList: [],
      baseLists: [],
      enableTable: false,
      selectedRow: null,
      fishPondList: [],
      topPondList: [],
      fishList: [],
      emptyRow: {
        pond: null,
        fishBatch: null,
        fishBatchId: null,
        productId: null,
        measureUnit: "",
        productName: "",
        survivalRate: 0,
        avgBodyLen: 0,
        avgWeight: 0,

        weight: 0,
        quantity: 0,
        remark: ""
      }
    };
  },

  async mounted() {
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑打样管理" : "查看打样管理";
    } else {
      document.title = "增加打样管理";
    }
    this.baseLists = await this.getBaseList(); //基地
    let proofingBase = storage.get("base");
    let oldBase = this.baseLists.find(f => f.key == proofingBase);
    if (proofingBase && oldBase) {
      this.order.fishBaseId = oldBase.key;
      await this.baseChange(this.order.fishBaseId);
    } else if (this.baseLists.length > 0) {
      this.order.fishBaseId = this.baseLists[0].key;
      await this.baseChange(this.order.fishBaseId);
    }

    this.initData();
  },
  methods: {
    ...mapActions(modules.proofing, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
      addProofing: "addProofing", //添加
      updateProofing: "updateProofing", //修改
      getEditProofing: "getEditProofing", //编辑--获取行数据
      delProofing: "delProofing" //删除
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch"
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.fish, {
      getPondFishList: "getPondFishList" //塘口下的渔种
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber"
    }),
    ...mapActions(['delVisitedViews']),
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    //初始化数据
    async initData() {
      if (!this.orderId) {
        //新增
        this.order.numericalOrder = await this.getSerialNumber();
        this.topPondList = await this.getFishPond(this.order.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });
        this.initTable();
      } else {
        //修改
        let result = await this.getEditProofing(this.orderId);
        this.order.fishBaseId = result.fishBaseId;
        await this.baseChange(result.fishBaseId);
        // result.details.forEach(async item => {
        //   item.fishEdit = false;
        //   item.fishBatch = item.fishBatchNo;
        //   item.pondEdit = false;
        //   // console.log(1212, item);
        //   this.fishList = await this.getPondFishList(item.fishBatchId);
        //   let a = this.fishList.find(f => f.id == item.fishId);
        //   if (a) {
        //     item.productId = a.id;
        //     item.productName = a.name;
        //     item.measureUnit = a.unitName;
        //   }
        //   console.log(1212, item);
        //   // console.log(6666, this.fishList, a);
        // });
        if (result.fishPondId === null) {
          console.log(11111, this.order.pond);

          let promises = result.details.map(item =>
            (async () => {
              item.fishEdit = false;
              item.fishBatch = item.fishBatchNo;
              item.pondEdit = false;
              item.fishList = await this.getPondFishList(item.fishBatchId);
              let a = item.fishList.find(f => f.id == item.fishId);
              if (a) {
                item.productId = a.id;
                item.productName = a.name;
                item.measureUnit = a.unitName;
              }
            })()
          );
          // await Promise.all(promises);
        } else {
          let promises = result.details.map(item =>
            (async () => {
              item.fishEdit = false;
              item.fishBatch = item.fishBatchNo;
              item.pondEdit = false;
              // console.log(1212, item);
              this.fishList = await this.getPondFishList(item.fishBatchId);
              let a = this.fishList.find(f => f.id == item.fishId);
              if (a) {
                item.productId = a.id;
                item.productName = a.name;
                item.measureUnit = a.unitName;
              }
            })()
          );
          await Promise.all(promises);
        }

        this.order = result;
        this.orderId = result.orderId;
        this.topPondList = await this.getFishPond(result.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });
        if (result.fishPondId === null) {
          this.order.pond = "";
        } else {
          this.order.pond = result.fishPondId;
          this.order.fishBatch = result.details[0].fishBatchNo;
          this.order.fishBatchId = result.details[0].fishBatchId;
        }
      }
      this.enableTable = true;
    },
    //改变基地数据
    async baseChange(e) {
      storage.set("base", e);
      this.getFishPond(e)
        .then(data => {
          this.fishPondList = data;
          if (this.fishPondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下面无塘口，请先添加",
              duration: 5000,
              status: "error"
            });
          }
        })
        .catch(() => {});

      this.enableTable = true;
      this.order.details.forEach(f => {
        f.pond = null;
        f.fishBatchId = null;
        f.fishBatch = null;
      });
      if (!this.orderId) {
        this.topPondList = await this.getFishPond(e);
        this.order.pond = "";
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });
      }
    },
    async topPondChange(e) {
      if (!e) {
        //当什么都没有选中，则清理
        this.order.fishBatchId = "";
        this.order.fishBatch = null;
        return;
      }

      let result = await this.getPondUnclearedBatchNo(e);
      if (result) {
        this.order.fishBatchId = result.key;
        this.order.fishBatch = result.value;
        this.order.details.forEach(async (f, index) => {
          console.log(2, f);
          f.productId = null;
          f.measureUnit = null;
          f.productName = null;
        });

        this.fishList = await this.getPondFishList(result.key);
        if (this.fishList.length == 0) {
          this.$Alert.info({
            content: "此塘口当前周期无进苗数据",
            duration: 5000,
            status: "error"
          });
        }
        // Message.error("此塘口当前周期无进苗数据");
      } else {
        try {
          await MessageBox.confirm("此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
          this.order.fishBatchId = "";
          this.order.fishBatch = "";
        } catch (error) {
          this.order.pond = "";
        }
      }
    },
    //改变塘口--联动周期
    async pondChange(row) {
      if (!row.pond) {
        //当什么都没有选中，则清理
        row.fishBatchId = null;
        row.fishBatch = null;
        return;
      }
      let result = await this.getPondUnclearedBatchNo(row.pond);
      if (result) {
        row.fishBatchId = result.key;
        row.fishBatch = result.value;
        row.productId = null;
        row.measureUnit = null;
        row.productName = null;
        row.fishList = await this.getPondFishList(result.key);
        console.log(78787, row.fishList);
        row.productId = row.fishList[0].id;
        row.productName = row.fishList[0].name;
        row.measureUnit = row.fishList[0].unitName;
        if (row.fishList.length == 0) {
          this.$Alert.info({
            content: "此塘口当前周期无进苗数据",
            duration: 5000,
            status: "error"
          });
        }
        // Message.error("此塘口当前周期无进苗数据");
      } else {
        try {
          await MessageBox.confirm("此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
        } catch (error) {
          row.pond = null;
        }
      }
    },
    fishChange(row) {
      if (this.order.pond == "") {
        let item = row.fishList.find(f => f.id == row.productId);
        if (item) {
          row.productName = item.name;
          row.measureUnit = item.unitName;
        }
      } else {
        let item = this.fishList.find(f => f.id == row.productId);
        if (item) {
          row.productName = item.name;
          row.measureUnit = item.unitName;
        }
      }
    },
    //保存
    async onSave() {
      let err = null;
      if (!this.order.fishBaseId) err = "基地必须选择";
      if (!this.order.dataDate) err = "日期必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      let list = [];
      if (this.order.pond == "") {
        list = this.order.details.filter(f => {
          return f.pond !== "" && f.pond !== null;
        });
      } else {
        list = this.order.details.filter(f => {
          return f.productId !== "" && f.productId !== null;
        });
        list.map(item => {
          item.pond = this.order.pond;
          item.fishBatch = this.order.fishBatch;
          item.fishBatchId = this.order.fishBatchId;
        });
      }
      let weightReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //重量
      let avgWeightReg = /^[0-9]{1,6}([.][0-9]{1,4})?$/; //均重
      let quantityReg = /^[0-9]{1,12}$/; //数量
      let survivalRateReg = /^[0-9]{1,3}([.][0-9]{1,2})?$/; //存活率
      let avgBodyLenReg = /^[0-9]{1,3}([.][0-9]{1,2})?$/; //体长
      if (list.length == 0) err = "不能提交空表单";
      list.forEach(item => {
        if (item.quantity === 0) {
          err = "请输入数量";
        }
        if (item.weight === 0) {
          err = "请输入打样总斤数";
        }
        if (item.avgWeight === 0) {
          err = "请输入均重";
        }

        if (!avgWeightReg.test(item.avgWeight)) {
          err = "均重范围为0~999999.0000";
        }
        if (!weightReg.test(item.weight)) {
          err = "重量范围至多12位整数,2位小数";
        }
        if (!survivalRateReg.test(item.survivalRate)) {
          err = "存活率范围为0~100.00";
        }
        if (!avgBodyLenReg.test(item.avgBodyLen)) {
          err = "体长范围为0~999.00";
        }
        if (!quantityReg.test(item.quantity)) {
          err = "数量只允许输入整数";
        }
        if (!item.pond) err = "塘口必须选择";
        if (!item.fishBatch || !item.fishBatchId) err = "批次必须选择";
        if (!item.productId || !item.productName) err = "品种必须选择";
      });

      if (err) {
        Message.error(err);
        return;
      }

      if (list.length > 0) this.order.details = list;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            let result = await this.updateProofing({
              id: this.orderId,
              data: this.order
            });
            this.order.billsNo = result.billNo;
            this.orderId = result.orderId;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            let result = await this.addProofing(this.order);
            this.orderId = result.orderId;
            this.order.billsNo = result.billNo;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          this.enableTable = false;
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // Message.error(error.response.data);
        }
      });
    },
    onAlter() {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach(item => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd() {
      this.order.billsNo = 0;
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(() => this.initData());
    },
    async onDelete() {
      if (!this.orderId) {
        this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error"
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delProofing(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack() {
      this.initData();
      this.edit = false
      this.enableTable = false
    },
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow() {
      this.order.details = this.order.details.filter(
        f => f != this.selectedRow
      );
    },
    setQuantityAmount(item) {
      if (item.avgWeight !== 0) {
        item.quantity = Math.ceil(Number(item.weight) / Number(item.avgWeight));
      }
    },
    setAvgWeightAmount(item) {
      if (item.quantity !== 0) {
        item.avgWeight = Number(
          (Number(item.weight) / Number(item.quantity)).toFixed(2)
        );
      }
    },
    closeView(){
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.replace('/productionControl/proofingManagement')
    }
  }
};
</script>
<style>
.addProofing .add-content-container,
.addProofing .add-titieMain {
  /* height: 190px; */
}
.addProofing .add-content-container .add-titieMain .add-content {
  /* height: 150px; */
}
.addProofing .custom-search-container {
  margin-top: 25px;
}
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}

.readonlys input {
  pointer-events: none;
  background: #f5f7fa;
}
</style>
